// Custom: Mini cart tab order fixes
// Custom: Move focus to subtotal after close button in mini cart
(function () {
  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(', ');

  function getMiniCartFocusable(miniCart) {
    return miniCart ? Array.prototype.slice.call(miniCart.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }) : [];
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;

    var active = document.activeElement;
    if (!active || !active.classList.contains('quantity_changed')) return;

    var miniCart = document.querySelector('.min_cart.active');
    if (!miniCart) return;

    var focusable = getMiniCartFocusable(miniCart);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (!e.shiftKey && active === last) {
      var subtotal = document.querySelector('.mmc_title.mmc_footer_txt');
      if (subtotal) {
        e.preventDefault();
        setTimeout(function () {
          subtotal.focus();
        }, 10);
      }
    } else if (e.shiftKey && active === first) {
      var currentRow = active.closest('.mmc_items');
      var plusBtn = currentRow ? currentRow.querySelector('.mmc_plus') : null;
      if (plusBtn) {
        e.preventDefault();
        plusBtn.focus();
      }
    }
  });
})();



// ADA fixes for Dawn theme - by Out of the Sandbox
(function () {

  function fixThumbnailAccessibility() {

    // Fix empty overlay links
    document.querySelectorAll('.thumbnail-overlay__container > a:first-child').forEach(link => {
      if (!link.textContent.trim() && !link.querySelector('img')) {
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
      }
    });

    // Fix hidden product links
    document.querySelectorAll('.thumbnail-overlay__container .hidden-product-link').forEach(link => {
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('tabindex', '-1');
    });

  }

  // Run on initial load
  document.addEventListener("DOMContentLoaded", function () {
    fixThumbnailAccessibility();
  });

  // Observe DOM changes (Shopify loads products dynamically)
  const thumbnailObserver = new MutationObserver(() => {
    fixThumbnailAccessibility();
  });

  thumbnailObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


// Fix ARIA issues with Boost PFS filters by adding aria-labels to checkboxes that are missing them
function fixBrokenFilterARIA() {
  document.querySelectorAll('.boost-pfs-check-box[role="checkbox"]').forEach(box => {

    const labelledby = box.getAttribute('aria-labelledby');

    if (labelledby && !document.getElementById(labelledby)) {

      const labelText = box.closest('.boost-pfs-filter-button')
        ?.querySelector('.boost-pfs-filter-option-value')
        ?.textContent.trim();

      if (labelText) {
        box.removeAttribute('aria-labelledby');
        box.setAttribute('aria-label', labelText);
      }
    }
  });
}

// Run initially
document.addEventListener("DOMContentLoaded", fixBrokenFilterARIA);

// Watch for filter updates
const observer = new MutationObserver(fixBrokenFilterARIA);

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Ensure collapsed Boost PFS filter panels are removed from the accessibility tree and keyboard tab order.
(function () {
  function syncBoostFilterPanelState() {
    document.querySelectorAll('.boost-pfs-filter-option').forEach(function (option) {
      const titleButton = option.querySelector('.boost-pfs-filter-option-title-heading');
      const panel = option.querySelector('.boost-pfs-filter-option-content');

      if (!titleButton || !panel) return;

      const isExpanded = titleButton.getAttribute('aria-expanded') === 'true';

      panel.toggleAttribute('hidden', !isExpanded);
      panel.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');

      if (isExpanded) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
    });
  }

  function initBoostFilterPanelState() {
    syncBoostFilterPanelState();

    document.removeEventListener('click', handleBoostFilterPanelToggle);
    document.removeEventListener('keydown', handleBoostFilterPanelToggle);
    document.addEventListener('click', handleBoostFilterPanelToggle);
    document.addEventListener('keydown', handleBoostFilterPanelToggle);
  }

  function handleBoostFilterPanelToggle(event) {
    const trigger = event.target.closest('.boost-pfs-filter-option-title-heading');

    if (!trigger) return;

    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;

    window.requestAnimationFrame(syncBoostFilterPanelState);
  }

  document.addEventListener('DOMContentLoaded', initBoostFilterPanelState);

  const boostFilterObserver = new MutationObserver(function () {
    syncBoostFilterPanelState();
  });

  boostFilterObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-expanded', 'class', 'style', 'hidden']
  });
})();

// Add tabindex to announcement bar text for accessibility
document.addEventListener("DOMContentLoaded", function () {
  const bar = document.querySelector('.announcement-bar__text');

  if (bar) {
    const firstP = bar.querySelector('p:first-of-type');

    if (firstP) {
      firstP.setAttribute('tabindex', '0');
    }
  }
});

// Add tabindex to mega menu content for accessibility
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.mega-menu__content.content p').forEach(p => {
    p.setAttribute('tabindex', '0');
  });
});

// Hide secondary images in product thumbnails from screen readers and keyboard navigation to prevent confusion, as they are decorative and not meant to be focused on or read by assistive technologies.
(function () {

  function hideSecondaryImages() {

    const secondaryImages = document.querySelectorAll(
      '.product__imageContainer img.secondary, img.secondary'
    );

    secondaryImages.forEach(img => {

      // Hide from screen readers
      img.setAttribute('aria-hidden', 'true');

      // Decorative image → empty alt
      img.setAttribute('alt', '');

      // Prevent accidental focus (rare but safe)
      img.setAttribute('tabindex', '-1');

    });

  }

  // Run on load
  window.addEventListener('load', hideSecondaryImages);

  // Run after AJAX / Boost / infinite scroll / filters
  const observer = new MutationObserver(hideSecondaryImages);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

// Fix ARIA labels on color swatches that are missing them, which can happen when using certain metafield naming conventions that include "meta" and "print", by cleaning up the swatch name and applying it as an aria-label for better accessibility.
(function () {

  function fixSwatchLabels() {

    const swatches = document.querySelectorAll('a.swatch');

    swatches.forEach(swatch => {

      const swatchName = swatch.getAttribute('data-swatch-name');
      if (!swatchName) return;

      // Clean value (meta-print_crimson_floral → Crimson Floral)
      const cleanName = swatchName
        .replace(/meta[-_]?print[-_]?/i, '')
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase())
        .trim();

      // Replace bad aria-label
      swatch.setAttribute('aria-label', `select ${cleanName}`);

    });

  }

  // Run after load
  window.addEventListener('load', fixSwatchLabels);

  // Re-run after Boost / AJAX / filtering
  const observer = new MutationObserver(fixSwatchLabels);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

// Focus on error messages when they appear on the login form to ensure they are announced by screen readers and easily noticed by keyboard users, improving accessibility for users who encounter login issues.
window.addEventListener('load', function () {

  const errorsContainer = document.querySelector('.errors');
  if (errorsContainer) {
    errorsContainer.setAttribute('role', 'alert');
    errorsContainer.setAttribute('aria-live', 'assertive');
  }

  const errorBox = document.querySelector('.errors ul li');

  if (errorBox) {

    errorBox.setAttribute('tabindex', '0');
    errorBox.focus();

  }

});

// Hide empty "Open this option" links in thumbnail overlays that can appear when there are no variant options, which can cause confusion for screen reader and keyboard users, by adding aria-hidden and tabindex attributes to hide them from assistive technologies and prevent them from being focusable.
document.querySelectorAll('.thumbnail-overlay__container > a[aria-label="Open this option"]')
  .forEach(function (link) {
    link.setAttribute('aria-hidden', 'true');
    link.setAttribute('tabindex', '-1');
  });

// Add tabindex to product description paragraphs for better accessibility, allowing keyboard users to navigate through the product description text and have it announced by screen readers, improving the overall user experience for those relying on assistive technologies.
window.addEventListener('load', function () {
  const paragraphs = document.querySelectorAll('.image-with-text__text p');

  paragraphs.forEach(function (paragraph) {
    paragraph.setAttribute('tabindex', '0');
  });
});

// Split the taxes and shipping message in the mini cart into separate focusable elements to ensure that screen readers can properly announce the information and keyboard users can navigate through it effectively, improving accessibility for users reviewing their cart details.
document.addEventListener('DOMContentLoaded', function () {

  const paragraph = document.querySelector('.mmc_footer_txt.cart__taxes-shipping-message');
  if (!paragraph) return;

  const link = paragraph.querySelector('a');
  if (!link) return;

  const nodes = Array.from(paragraph.childNodes);

  let beforeText = '';
  let afterText = '';
  let foundLink = false;

  nodes.forEach(node => {
    if (node === link) {
      foundLink = true;
    } else if (!foundLink && node.nodeType === 3) {
      beforeText += node.textContent;
    } else if (foundLink && node.nodeType === 3) {
      afterText += node.textContent;
    }
  });

  paragraph.innerHTML = '';

  // BEFORE SPAN
  if (beforeText) {
    const beforeSpan = document.createElement('span');
    beforeSpan.textContent = beforeText;
    beforeSpan.setAttribute('tabindex', '0');
    paragraph.appendChild(beforeSpan);
  }

  // Add space before link if needed
  paragraph.appendChild(document.createTextNode(' '));

  // LINK
  paragraph.appendChild(link);

  // Add space after link
  paragraph.appendChild(document.createTextNode(' '));

  // AFTER SPAN
  if (afterText) {
    const afterSpan = document.createElement('span');
    afterSpan.textContent = afterText.trim();
    afterSpan.setAttribute('tabindex', '0');
    paragraph.appendChild(afterSpan);
  }

});

// Trap focus within the mini cart when it's open to prevent keyboard users from accidentally tabbing out of the cart and into the underlying page content, improving accessibility and user experience for those navigating with a keyboard.
(function () {

  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'textarea',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(', ');

  function handleMiniCartTab(e) {
    if (e.key !== 'Tab') return;

    // Only act when the mini cart is open
    var miniCart = document.querySelector('.min_cart.active');
    if (!miniCart) return;

    // Re-query every time so AJAX-refreshed content (including Continue Shopping) is always included
    var focusable = Array.prototype.slice.call(miniCart.querySelectorAll(FOCUSABLE));
    // Filter to only truly visible/focusable elements
    focusable = focusable.filter(function (el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });

    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      // SHIFT+TAB: wrap from first → last
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      // TAB: wrap from last → first
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  document.addEventListener('keydown', handleMiniCartTab);

})();


// Add ARIA labels to Fancybox navigation buttons for better accessibility, ensuring that screen readers can announce the purpose of the previous and next buttons in the image gallery, improving the user experience for those relying on assistive technologies.
document.addEventListener('click', function () {

  setTimeout(function () {

    const prevBtn = document.querySelector('[data-fancybox-prev]');
    const nextBtn = document.querySelector('[data-fancybox-next]');

    if (prevBtn) {
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.removeAttribute('title');
    }

    if (nextBtn) {
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.removeAttribute('title');
    }

    // Hide SVG from screen readers
    document.querySelectorAll('.fancybox-button svg')
      .forEach(svg => svg.setAttribute('aria-hidden', 'true'));

  }, 300); // delay so Fancybox fully renders

});

// Add ARIA labels to Fancybox control buttons for better accessibility, ensuring that screen readers can announce the purpose of the zoom, play, thumbnails, and close buttons in the image gallery, improving the user experience for those relying on assistive technologies.
document.addEventListener('click', function () {

  setTimeout(function () {

    const zoomBtn = document.querySelector('[data-fancybox-zoom]');
    const playBtn = document.querySelector('[data-fancybox-play]');
    const thumbsBtn = document.querySelector('[data-fancybox-thumbs]');
    const closeBtn = document.querySelector('[data-fancybox-close]');

    if (zoomBtn) {
      zoomBtn.setAttribute('aria-label', 'Zoom image');
      zoomBtn.removeAttribute('title');
    }

    if (playBtn) {
      playBtn.setAttribute('aria-label', 'Start slideshow');
      playBtn.removeAttribute('title');
    }

    if (thumbsBtn) {
      thumbsBtn.setAttribute('aria-label', 'Show thumbnails');
      thumbsBtn.removeAttribute('title');
    }

    if (closeBtn) {
      closeBtn.setAttribute('aria-label', 'Close gallery');
      closeBtn.removeAttribute('title');
    }

    // Hide all SVG icons from screen readers
    document.querySelectorAll('.fancybox-button svg')
      .forEach(svg => svg.setAttribute('aria-hidden', 'true'));

  }, 300);

});

// Add tabindex to product description paragraphs for better accessibility, allowing keyboard users to navigate through the product description text and have it announced by screen readers, improving the overall user experience for those relying on assistive technologies.
$(document).ready(function () {
  var $container = $('.pdacd_description');

  // 1. Add tabindex to the list items and paragraphs
  $container.find('li, p').attr('tabindex', '0');
  $container.find('ul li').attr('tabindex', '0');
  $container.find('p span').attr('tabindex', '0');

  // 2. Remove tabindex from the parent container to prevent "double tabbing"
  // This ensures the focus goes directly to the first line of text.
  if ($container.find('li, p').length > 0) {
    $container.removeAttr('tabindex');
  }

  // 3. Optional: Fix for empty <p> tags (like the one at the top of your HTML)
  $container.find('p').each(function () {
    if ($(this).text().trim() === "") {
      $(this).removeAttr('tabindex'); // Don't focus empty lines
    }
  });
});

// Force hide zoom images added by the library with aria-hidden and other attributes to ensure they are not announced by screen readers or focusable, as they are decorative and can cause confusion for users relying on assistive technologies.

(function () {
  const forceHideZoom = (img) => {
    if (img.getAttribute('aria-hidden') !== 'true') {
      img.setAttribute('aria-hidden', 'true');
      img.setAttribute('alt', ''); // Ensure alt is empty
      img.setAttribute('tabindex', '-1'); // Remove from tab order
      img.setAttribute('role', 'presentation'); // Extra reinforcement
    }
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // 1. Catch newly added images
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.classList.contains('zoomImg')) forceHideZoom(node);
          node.querySelectorAll('.zoomImg').forEach(forceHideZoom);
        }
      });
      // 2. Catch if the library tries to remove the attribute on an existing image
      if (mutation.type === 'attributes' && mutation.target.classList.contains('zoomImg')) {
        forceHideZoom(mutation.target);
      }
    });
  });

  // Start watching the body
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden', 'alt', 'src', 'class']
  });

  // Initial run for images already on page
  document.querySelectorAll('.zoomImg').forEach(forceHideZoom);
})();

// Function to hide secondary images for accessibility by adding aria-hidden, role, alt, and tabindex attributes
function hideSecondaryImages() {
  document.querySelectorAll('.slider-gallery img.secondary, .product__imageContainer img.secondary').forEach(function (img) {

    img.setAttribute('aria-hidden', 'true');
    img.setAttribute('role', 'presentation');
    img.setAttribute('alt', '');
    img.setAttribute('tabindex', '-1');

    var wrapper = img.closest('.image-element__wrap');
    if (wrapper) {
      wrapper.setAttribute('aria-hidden', 'true');
    }

  });
}

document.addEventListener("DOMContentLoaded", hideSecondaryImages);
window.addEventListener("load", hideSecondaryImages);

// Function to add accessibility attributes to the current image in the Fancybox gallery, ensuring that it is focusable and announced as an image by screen readers, improving the user experience for those relying on assistive technologies.
function updateFancyboxImageAccessibility() {

  const currentImg = document.querySelector('.fancybox-slide--current img.fancybox-image');

  if (currentImg && !currentImg.hasAttribute('tabindex')) {
    currentImg.setAttribute('tabindex', '0');
    currentImg.setAttribute('role', 'img');
  }

}

// run repeatedly while fancybox is open
setInterval(function () {

  if (document.querySelector('.fancybox-container')) {
    updateFancyboxImageAccessibility();
  }

}, 300);

// Function to add accessibility attributes to the product description in the Fancybox quick shop, allowing keyboard users to navigate through the description text and have it announced by screen readers, improving the overall user experience for those relying on assistive technologies.
function applyDescriptionAccessibility() {

  var $container = $('.fancybox-container .pdacd_description');

  if ($container.length) {

    // add tabindex to paragraphs and list items
    $container.find('li, p').attr('tabindex', '0');
    $container.find('ul li').attr('tabindex', '0');

    // remove tabindex from container
    if ($container.find('li, p').length > 0) {
      $container.removeAttr('tabindex');
    }

    // remove tabindex from empty paragraphs
    $container.find('p').each(function () {
      if ($(this).text().trim() === "") {
        $(this).removeAttr('tabindex');
      }
    });

  }
}

document.addEventListener('click', function () {

  setTimeout(function () {
    applyDescriptionAccessibility();
  }, 500); // wait for quick shop content to render

});

// Function to make swatch titles accessible in the Fancybox quick shop by adding tabindex, role, aria-live, and aria-label attributes, ensuring that screen readers can announce the swatch options and keyboard users can navigate to them effectively, improving accessibility for users selecting product variants.
// function makeSwatchReadable() {
//   const swatchTitle = document.querySelector('.fancybox-content .options-selection__option-name');

//   if (swatchTitle) {
//     swatchTitle.setAttribute('tabindex', '0'); // make focusable
//     swatchTitle.setAttribute('role', 'heading');
//     swatchTitle.setAttribute('aria-live', 'polite');
//     swatchTitle.setAttribute('aria-label', swatchTitle.innerText);
//   }
// }

// Only make the swatch readable when the details section is focused
document.addEventListener('focusin', function (e) {
  if (e.target.matches('.product__view-details')) {
    setTimeout(makeSwatchReadable, 300); // do not focus automatically
  }
});

// Function to fix keyboard navigation from Shop Pay wallet button to "More payment options" link by adding a keydown listener that intercepts the Tab key and manually moves focus to the next logical element, improving accessibility for keyboard users navigating the checkout options.
document.addEventListener('focusin', (e) => {
  const walletButton = document.querySelector('shop-pay-wallet-button');
  const moreOptions = document.querySelector('#more-payment-options-link');

  if (walletButton && moreOptions) {
    // Make sure the wallet button itself is tabbable
    if (!walletButton.hasAttribute('tabindex')) walletButton.setAttribute('tabindex', '0');

    // Intercept Tab when wallet button is focused
    walletButton.addEventListener('keydown', function (evt) {
      if (evt.key === 'Tab' && !evt.shiftKey) {
        evt.preventDefault(); // stop default "trapped focus"
        moreOptions.focus(); // manually move to next button
      }
    });
  }
});

// Function to update ARIA labels on the small close button in the Fancybox quick shop for better accessibility, ensuring that screen readers can announce the purpose of the close button accurately, improving the user experience for those relying on assistive technologies.
(function () {
  const updateFancyboxAccessibility = () => {
    // Target the small close button specifically
    const closeBtns = document.querySelectorAll('.fancybox-close-small, [data-fancybox-close]');

    closeBtns.forEach(btn => {
      // Only set it if it hasn't been set yet to avoid constant re-runs
      if (btn.getAttribute('aria-label') !== 'Close') {
        btn.setAttribute('aria-label', 'Close');
        // Ensure the SVG inside is hidden so it doesn't try to read paths
        const svg = btn.querySelector('svg');
        if (svg) svg.setAttribute('aria-hidden', 'true');

      }
    });
  };

  // Watch the body for the Fancybox popup being added to the DOM
  const observer = new MutationObserver((mutations) => {
    updateFancyboxAccessibility();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Run once in case it's already open
  updateFancyboxAccessibility();
})();

// Function to remove tabindex from logo images in the header to prevent them from being focusable, as they are decorative and not meant to be interactive elements, improving accessibility for users navigating with a keyboard or assistive technologies.
function removeLogoTabindex() {
  var logoImages = document.querySelectorAll('.header__logo img');

  logoImages.forEach(function (img) {
    img.removeAttribute('tabindex');
  });
}

// Run after page loads
document.addEventListener('DOMContentLoaded', function () {
  removeLogoTabindex();
});

// Function to fix ARIA issues with variant option names in the Fancybox quick shop by restructuring the HTML to separate the option name and value into distinct elements with appropriate ARIA attributes, improving accessibility for screen readers and keyboard users when selecting product variants.
(function () {

  function fixVariantOptionAccessibility() {

    document.querySelectorAll('.options-selection__option-name').forEach(function (container) {

      // Remove tabindex from parent
      container.removeAttribute('tabindex');

      // Prevent duplicate processing
      if (container.querySelector('.ada-option-label')) return;

      const textNode = container.childNodes[0];

      if (textNode && textNode.nodeType === 3 && textNode.textContent.trim() !== '') {

        const labelSpan = document.createElement('span');
        labelSpan.className = 'ada-option-label';
        labelSpan.setAttribute('tabindex', '0');
        labelSpan.textContent = textNode.textContent.trim();

        // Insert label span
        container.insertBefore(labelSpan, textNode);

        // Add space after first span
        const space = document.createTextNode(' ');
        container.insertBefore(space, textNode);

        // Remove original text node
        container.removeChild(textNode);
      }

      // Add tabindex to value span
      const valueSpan = container.querySelector('span:not(.ada-option-label)');
      if (valueSpan) {
        valueSpan.setAttribute('tabindex', '0');
      }

    });

  }

  document.addEventListener("DOMContentLoaded", function () {
    fixVariantOptionAccessibility();
  });

  const variantObserver = new MutationObserver(function () {
    fixVariantOptionAccessibility();
  });

  variantObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


// Function to fix keyboard navigation in the installment tab of the Fancybox quick shop by adding a keydown listener that intercepts the Tab key and manually moves focus between the "Learn more" button, the description, and the price, creating a logical focus loop for better accessibility.
(function () {

  function fixInstallmentTabbing() {

    const learnMoreBtn = document.querySelector('#quickshop shopify-payment-terms');
    const nextElement = document.querySelector('#quickshop .description_top p');
    const prevElement = document.querySelector('#quickshop .modal_price .money');

    if (!learnMoreBtn || !nextElement || !prevElement) return;

    learnMoreBtn.addEventListener('keydown', function (e) {

      // TAB → go to description
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        nextElement.focus();
      }

      // SHIFT + TAB → go to price
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        prevElement.focus();
      }

    });

  }

  // Detect Quick Shop / Fancybox opening
  document.addEventListener('click', function () {

    setTimeout(function () {
      fixInstallmentTabbing();
    }, 600); // wait for popup content to render

  });

})();

// Function to fix accessibility issues with the footer logo by adding tabindex attributes to hide it from screen readers and prevent it from being focusable, as it is decorative and not meant to be an interactive element, improving accessibility for users navigating with a keyboard or assistive technologies.
(function () {

  function fixFooterLogoAccessibility() {

    const footerImages = document.querySelectorAll('.footer__logo-wrapper img');

    footerImages.forEach(function (img) {
      img.setAttribute('tabindex', '-1');
    });

  }

  document.addEventListener('DOMContentLoaded', fixFooterLogoAccessibility);

})();


// ADA fix: Announce "Viewing details of [product]" when user presses Enter on a
// product image or title link. Uses aria-live so the SR speaks it at activation time.
(function () {

  function getAnnouncer() {
    var el = document.getElementById('product-link-announcer');
    if (!el) {
      el = document.createElement('div');
      el.id = 'product-link-announcer';
      el.setAttribute('aria-live', 'assertive');
      el.setAttribute('aria-atomic', 'true');
      el.style.position = 'absolute';
      el.style.width = '1px';
      el.style.height = '1px';
      el.style.margin = '-1px';
      el.style.padding = '0';
      el.style.overflow = 'hidden';
      el.style.clip = 'rect(0,0,0,0)';
      el.style.border = '0';
      document.body.appendChild(el);
    }
    return el;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;

    var productName = '';
    var href = '';

    // Case 1: Enter on the product image link.
    // Do NOT use link.textContent — lazy-load renders output image URLs as text nodes.
    // Instead walk the DOM to find the product title.
    var imageLink = e.target.closest('.image__container.product__imageContainer a, .boost-sd__product-image-wrapper a');
    if (imageLink) {
      href = imageLink.getAttribute('href');
      var card = imageLink.closest('.product-wrap, .product__thumbnail, .thumbnail');
      if (card) {
        // Try multiple selectors to ensure we catch the product name
        var titleEl = card.querySelector('.hidden-product-link, a.product-thumbnail__title, .product-thumbnail__title');
        if (titleEl) {
          productName = titleEl.textContent.trim();
        }

        // Fallback: if title not found, try to get it from image alt text or other sources
        if (!productName) {
          var img = card.querySelector('img');
          if (img) {
            var altText = img.getAttribute('alt') || '';
            // Extract product name from alt text (e.g., "A lady wearing Product Name" → "Product Name")
            productName = altText.replace(/^(a |an |the )?(?:lady|man|person|model|person wearing|showing)?\s*/i, '').trim();
          }
        }

        // Fallback: look for any heading or title text in the card
        if (!productName) {
          var headingEl = card.querySelector('h2, h3, h4, [role="heading"]');
          if (headingEl) {
            productName = headingEl.textContent.trim();
          }
        }
      }
    }

    // Case 2: Enter on the product title link.
    var titleLink = e.target.closest('a.product-thumbnail__title, a.boost-sd__product-link');
    if (titleLink) {
      href = titleLink.getAttribute('href');
      var ariaLabel = titleLink.getAttribute('aria-label') || '';
      productName = ariaLabel.replace(/^view details of\s*/i, '').trim()
        || titleLink.textContent.trim();
    }

    // Case 3: Enter on a swatch link.
    var swatchLink = e.target.closest('a.swatch');
    if (swatchLink) {
      href = swatchLink.getAttribute('href');
      // Get the clean swatch name from aria-label (format: "select Swatch Name")
      var swatchAriaLabel = swatchLink.getAttribute('aria-label') || '';
      productName = swatchAriaLabel.replace(/^select\s*/i, '').trim();

      // Fallback: clean the data-swatch-name if aria-label not available
      if (!productName) {
        var swatchDataName = swatchLink.getAttribute('data-swatch-name') || '';
        productName = swatchDataName
          .replace(/meta[-_]?print[-_]?/i, '')
          .replace(/[-_]/g, ' ')
          .replace(/\b\w/g, function (l) { return l.toUpperCase(); })
          .trim();
      }
    }

    if (!productName || !href) return;

    e.preventDefault();

    var announcer = getAnnouncer();
    announcer.textContent = '';

    setTimeout(function () {
      announcer.textContent = 'View details of ' + productName;
    }, 50);

    setTimeout(function () {
      window.location.href = href;
    }, 400);
  });

})();

// Function to populate missing alt attributes for product images in related products section
// This fixes accessibility issues where alt text is not loaded on initial page load
(function () {

  let debounceTimer;

  function populateMissingAltText() {

    // Target all product image containers (product slider / related products section)
    document.querySelectorAll('.product__imageContainer, .slider-gallery .image__container').forEach(function (container) {

      // Get all images in the container and find those with empty alt attributes
      const images = container.querySelectorAll('img');
      images.forEach(function (img) {
        // Only process images with empty alt
        if (img.getAttribute('alt') !== '' && img.getAttribute('alt') !== null) return;

        // Get the product card container
        const card = container.closest('.product-wrap, .gallery-cell, .thumbnail');
        if (!card) return;

        // Try to find product title from various locations
        let productTitle = '';

        // Method 1: Look for hidden product link (direct product name)
        const hiddenLink = card.querySelector('.hidden-product-link');
        if (hiddenLink) {
          productTitle = hiddenLink.textContent.trim();
        }

        // Method 2: Look for product title in the card
        if (!productTitle) {
          const titleEl = card.querySelector('.product-thumbnail__title, .product__title, h2, h3');
          if (titleEl) {
            productTitle = titleEl.textContent.trim();
          }
        }

        // Method 3: Get from link aria-label if it contains product name
        if (!productTitle) {
          const link = container.querySelector('a');
          if (link) {
            const ariaLabel = link.getAttribute('aria-label') || '';
            productTitle = ariaLabel.replace(/^(Open this option|View details of)\s*/i, '').trim();
          }
        }

        // Set the alt attribute if we found a product title
        if (productTitle) {
          img.setAttribute('alt', productTitle);
          // Ensure image is not hidden from screen readers
          if (img.getAttribute('aria-hidden') === 'true') {
            img.removeAttribute('aria-hidden');
          }
        }
      });
    });

  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', populateMissingAltText);
  window.addEventListener('load', populateMissingAltText);

  // Watch for dynamically added product images with debouncing
  const observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(populateMissingAltText, 300);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

// Function to ensure carousel slides with images are accessible to screen readers
// Even when visually hidden, carousel slides should have proper alt text and not be aria-hidden
(function () {

  function makeCarouselImagesAccessible() {

    // For product sliders/carousels, ensure all product cards are readable even if hidden visually
    document.querySelectorAll('.gallery-cell, .carousel-cell, [role="group"]').forEach(function (slide) {

      // Check if this slide contains product images
      const hasImages = slide.querySelector('img');
      if (!hasImages) return;

      // Don't hide entire slide from screen readers - images need to be readable
      if (slide.getAttribute('aria-hidden') === 'true') {
        slide.removeAttribute('aria-hidden');
      }

      // Ensure all images in the slide have alt text
      slide.querySelectorAll('img').forEach(function (img) {
        const alt = img.getAttribute('alt');
        if (alt === '' || alt === null) {
          // Try to get product name from the slide
          const titleEl = slide.querySelector('.product-thumbnail__title, .product__title, .hidden-product-link, h2, h3');
          if (titleEl) {
            img.setAttribute('alt', titleEl.textContent.trim());
          }
        }
      });

    });

  }

  // Run on load
  document.addEventListener('DOMContentLoaded', makeCarouselImagesAccessible);
  window.addEventListener('load', makeCarouselImagesAccessible);

  // Watch for carousel changes
  const observer = new MutationObserver(function () {
    clearTimeout(window.carouselAccessibilityTimer);
    window.carouselAccessibilityTimer = setTimeout(makeCarouselImagesAccessible, 300);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden', 'style', 'class']
  });

})();

// ADA fix: Announce "{filterName} has been selected / deselected" when user toggles a filter checkbox in Boost Filter.
(function () {
  /**
   * Creates a fresh, temporary assertive live region and announces the text.
   * This "fresh announcer" pattern is more reliable for consecutive updates.
   * @param {string} text The announcement text.
   */
  function announce(text) {
    const announcer = document.createElement('div');
    announcer.setAttribute('aria-live', 'assertive');
    announcer.setAttribute('aria-atomic', 'true');
    announcer.style.position = 'absolute';
    announcer.style.width = '1px';
    announcer.style.height = '1px';
    announcer.style.margin = '-1px';
    announcer.style.padding = '0';
    announcer.style.overflow = 'hidden';
    announcer.style.clip = 'rect(0,0,0,0)';
    announcer.style.border = '0';
    document.body.appendChild(announcer);

    // Short delay to ensure the SR registers the live region before text is added
    setTimeout(function () {
      announcer.textContent = text;
      // Cleanup: remove the announcer after it's likely been read
      setTimeout(function () {
        if (announcer.parentNode) {
          announcer.parentNode.removeChild(announcer);
        }
      }, 1500);
    }, 50);
  }

  /**
   * Extracts the filter name and triggers the announcement.
   * @param {HTMLElement} button The checkbox button element.
   */
  function handleFilterToggle(button) {
    if (!button) return;

    let filterName = '';
    const labelEl = button.querySelector('.boost-pfs__filter-option-item-label, .boost-pfs-filter-option-value');

    if (labelEl) {
      filterName = labelEl.textContent.trim();
    } else {
      const ariaLabel = button.getAttribute('aria-label') || button.getAttribute('title') || '';
      if (ariaLabel) {
        // Handle various Boost patterns: "Print: ColorName", "Find product with STYLE is StyleName", etc.
        filterName = ariaLabel
          .replace(/^(Find product with .* is |Print: |Color: |Find product with )/i, '')
          .split('.')[0]
          .trim();
      }
    }

    if (!filterName) return;

    // Use predicted state logic because Boost Filter often re-renders or stops propagation.
    const wasChecked = button.getAttribute('aria-checked') === 'true';
    const newStatus = wasChecked ? 'deselected' : 'selected';
    const announcement = filterName + ' has been ' + newStatus;

    // Delay slightly to avoid clashing with native SR behavior
    setTimeout(function () {
      announce(announcement);
    }, 250);
  }

  // Broad selector to catch Boost filter buttons even after their role is changed from 'checkbox' to 'button'.
  const filterSelector = 'button[role="checkbox"], button[role="button"][class*="boost-pfs"], .boost-pfs__filter-option-item-button, .boost-pfs__filter-option-swatch-item button';

  // Use the CAPTURE phase (true) to ensure we see the event even if Boost Filter calls stopPropagation().
  document.addEventListener('click', function (e) {
    // 1. Handle regular filter toggle (Checkboxes/Buttons)
    const button = e.target.closest(filterSelector);
    if (button) {
      handleFilterToggle(button);
      return;
    }

    // 2. Handle "Clear All" filters
    const clearAllBtn = e.target.closest('#boost-pfs__button--clear-all-filters, .boost-pfs-filter-clear-all');
    if (clearAllBtn) {
      announce('Filters all cleared. Results have been refreshed.');
      return;
    }

    // 3. Handle individual "Clear Filter" buttons (Refine By section)
    const clearItemBtn = e.target.closest('.boost-pfs__refine-by-vertical-refine-by-item, .refine-by-item');
    if (clearItemBtn) {
      const valueEl = clearItemBtn.querySelector('.boost-pfs__refine-by-vertical-refine-by-value, .refine-by-value');
      let filterName = '';
      if (valueEl) {
        filterName = valueEl.textContent.trim();
      } else {
        const ariaLabel = clearItemBtn.getAttribute('aria-label') || '';
        // Extract filter name from aria-label (e.g. "Clear STYLE: Chemise" -> "Chemise")
        filterName = ariaLabel.replace(/^Clear\s+/i, '').split(':')[1] || ariaLabel.replace(/^Clear\s+/i, '');
      }
      announce('Filter ' + filterName.trim() + ' cleared. Results have been refreshed.');
      return;
    }

    // 4. Handle "Clear" buttons on individual filter groups (e.g. "Clear: STYLE")
    const clearGroupBtn = e.target.closest('.boost-pfs__filter-option-label-btn, .boost-pfs-filter-clear');
    if (clearGroupBtn) {
      announce('Clear filter, results have been refreshed.');
    }
  }, true);

  /**
   * Changes the role of Boost filters from 'checkbox' to 'button' to suppress
   * the native "checked/unchecked" announcements, allowing our custom messages to take over.
   */
  function suppressNativeCheckboxSpeech() {
    const filters = document.querySelectorAll('button[role="checkbox"]');
    filters.forEach(function (btn) {
      if (btn.closest('#boost-pfs-filter-tree-column, .boost-pfs__filter-tree-vertical, .boost-pfs__filter-tree-vertical-content, .boost-pfs-filter-tree')) {
        btn.setAttribute('role', 'button');
      }
    });
  }

  // Run on initial load and observe for dynamic filter re-renders
  suppressNativeCheckboxSpeech();
  const observer = new MutationObserver(suppressNativeCheckboxSpeech);
  observer.observe(document.body, { childList: true, subtree: true });

})();

// Add to Cart Accessibility Announcement (Network + DOM Hybrid)
(function () {
  let pendingProductName = null;

  let announceCount = 0;
  const announceToSR = (msg) => {
    if (!msg) return;

    let announcer = document.getElementById('ada-cart-announcer');
    if (announcer) {
      document.body.removeChild(announcer);
    }

    announcer = document.createElement('div');
    announcer.id = 'ada-cart-announcer';
    announcer.setAttribute('role', 'status');
    announcer.setAttribute('aria-live', 'assertive');
    announcer.style.cssText = 'position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); border: 0;';
    document.body.appendChild(announcer);

    // Append invisible zero-width spaces to guarantee the string is always unique,
    // forcing the screen reader to announce it even if it's the exact same product added twice.
    announceCount++;
    const invisibleSuffix = '\u200B'.repeat(announceCount % 10);

    // Set the new text after a tiny delay so the browser registers the new element
    setTimeout(() => {
      announcer.textContent = msg + invisibleSuffix;
    }, 100);
  };

  const handleProductAdded = (productName) => {
    if (!productName) return;

    // Always queue the product name. We will wait for the theme to focus #PopupCartID.
    pendingProductName = productName;

    // Safety fallback: if the theme fails to focus #PopupCartID within 2.5 seconds, announce it anyway.
    clearTimeout(window._adaCartFallbackTimer);
    window._adaCartFallbackTimer = setTimeout(() => {
      if (pendingProductName === productName) {
        pendingProductName = null;
        announceToSR(productName + ' added to cart');
      }
    }, 2500);
  };

  const extractIdFromBody = (body) => {
    if (!body) return null;
    try {
      if (typeof body === 'string') {
        if (body.trim().startsWith('{')) {
          const parsed = JSON.parse(body);
          if (parsed.id) return parsed.id.toString();
          if (parsed.items && parsed.items[0] && parsed.items[0].id) return parsed.items[0].id.toString();
        } else {
          const params = new URLSearchParams(body);
          if (params.get('id')) return params.get('id');
        }
      } else if (body instanceof FormData) {
        if (body.get('id')) return body.get('id').toString();
      }
    } catch (e) { }
    return null;
  };

  const findProductTitle = (data, reqBody) => {
    if (data.title) return data.title;
    if (data.items && data.items.length > 0) {
      const targetId = extractIdFromBody(reqBody);
      if (targetId) {
        // Find the item matching the ID we just added
        const item = data.items.find(i => i.id.toString() === targetId || i.variant_id.toString() === targetId);
        if (item && item.title) return item.title;
      }
      // Fallback: Use the NEWEST item in the cart (last in the array), not the oldest
      return data.items[data.items.length - 1].title;
    }
    return null;
  };

  // 1. Intercept Fetch to get exact product variant name
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');

    if (url.includes('/cart/add')) {
      try {
        const reqBody = args.length > 1 ? args[1].body : null;
        const clone = response.clone();
        const data = await clone.json();

        const title = findProductTitle(data, reqBody);
        if (title) handleProductAdded(title);
      } catch (e) { }
    }
    return response;
  };

  // 2. Intercept XHR to get exact product variant name
  const originalXHROpen = window.XMLHttpRequest.prototype.open;
  const originalXHRSend = window.XMLHttpRequest.prototype.send;

  window.XMLHttpRequest.prototype.open = function (method, url) {
    this._reqUrl = url;
    originalXHROpen.apply(this, arguments);
  };

  window.XMLHttpRequest.prototype.send = function (body) {
    this.addEventListener('load', function () {
      if (typeof this._reqUrl === 'string' && this._reqUrl.includes('/cart/add')) {
        try {
          let data = null;
          if (this.responseType === 'json') {
            data = this.response;
          } else if (this.responseText) {
            data = JSON.parse(this.responseText);
          }

          if (data) {
            const title = findProductTitle(data, body);
            if (title) handleProductAdded(title);
          }
        } catch (e) { }
      }
    });
    originalXHRSend.apply(this, arguments);
  };

  // 3. Perfect Synchronization: Listen for UserWay's trigger (the focus event on PopupCartID)
  document.addEventListener('focus', (e) => {
    if (e.target && e.target.id === 'PopupCartID') {
      if (pendingProductName) {
        const productToAnnounce = pendingProductName;
        pendingProductName = null; // Clear immediately
        clearTimeout(window._adaCartFallbackTimer); // Cancel the fallback timer

        // The theme just focused the title, which means UserWay is reading it RIGHT NOW.
        // We wait exactly 1.2 seconds for UserWay to finish, then announce the product!
        setTimeout(() => {
          announceToSR(productToAnnounce + ' added to cart');
        }, 1200);
      }
    }
  }, true); // useCapture=true is required to catch focus events globally

})();

// Judge.me review widget accessibility fix
// Adds tabindex and ARIA attributes to review elements since we cannot modify the third-party app code.
(function () {

  function fixJudgeMeAccessibility() {

    var widget = document.querySelector('#judgeme_product_reviews');
    if (!widget) return;

    //widg title
    widget.querySelectorAll('.jdgm-rev-widg__title').forEach(function (el) {
      if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', '0');
    });

    // "Based on X reviews" text
    widget.querySelectorAll('.jdgm-rev-widg__summary-text').forEach(function (el) {
      if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', '0');
    });

    // Histogram percentage and frequency labels
    widget.querySelectorAll('.jdgm-histogram__percentage, .jdgm-histogram__frequency').forEach(function (el) {
      if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', '0');
    });

    // Individual reviews
    widget.querySelectorAll('.jdgm-rev').forEach(function (review) {

      // Rating stars
      var rating = review.querySelector('.jdgm-rev__rating');
      if (rating && !rating.getAttribute('tabindex')) {
        rating.setAttribute('tabindex', '0');
      }

      // Reviewer name
      var author = review.querySelector('.jdgm-rev__author');
      if (author && !author.getAttribute('tabindex')) {
        author.setAttribute('tabindex', '0');
      }

      // Review headline/title
      var title = review.querySelector('.jdgm-rev__title');
      if (title && !title.getAttribute('tabindex')) {
        title.setAttribute('tabindex', '0');
      }

      // Review body paragraphs
      review.querySelectorAll('.jdgm-rev__body p').forEach(function (p) {
        if (!p.getAttribute('tabindex')) p.setAttribute('tabindex', '0');
      });

    });

  }

  // Run once on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', fixJudgeMeAccessibility);

  // Re-run when Judge.me dynamically injects or updates reviews
  var jdgmObserver = new MutationObserver(function () {
    clearTimeout(window._jdgmA11yTimer);
    window._jdgmA11yTimer = setTimeout(fixJudgeMeAccessibility, 300);
  });

  jdgmObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


// Fix: Make Boost 'Refine By' headings focusable via tabindex for keyboard users
(function () {
  const selector = '.boost-pfs-filter-option-title-heading span';

  function ensureRefineHeadingTabindex() {
    document.querySelectorAll(selector).forEach(el => {
      // Only set when missing or different to avoid unnecessary writes
      if (!el.hasAttribute('tabindex') || el.getAttribute('tabindex') !== '0') {
        el.setAttribute('tabindex', '0');
      }
    });
  }

  // Run immediately (in case script loads after Boost renders)
  ensureRefineHeadingTabindex();

  // Also run on DOMContentLoaded for predictable timing
  document.addEventListener('DOMContentLoaded', ensureRefineHeadingTabindex);

  // Observe for dynamic insertions by the Boost app
  const refineObserver = new MutationObserver(ensureRefineHeadingTabindex);
  refineObserver.observe(document.body, { childList: true, subtree: true });

})();

// Trap focus in search popup and handle arrow & tab navigation: Input -> Suggestions -> Close -> Title -> Input
(function () {

  function getSuggestionItems(suggestionContainer) {
    if (!suggestionContainer) return [];
    var elements = suggestionContainer.querySelectorAll(
      '.boost-pfs-search-suggestion-item a, .boost-pfs-search-suggestion-header-view-all a, .boost-pfs-search-suggestion a'
    );
    var items = [];
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if ((el.offsetWidth || el.offsetHeight || el.getClientRects().length) && items.indexOf(el) === -1) {
        items.push(el);
      }
    }
    return items;
  }

  // Fix accessibility of search suggestion product items:
  // Removes aria-label from <li> (prevents "products: Title" double-reading),
  // sets a clean aria-label on each <a> (title + price, image alt in name),
  // and ensures the <a> is keyboard-focusable.
  function patchSearchItemAccessibility(suggestionContainer) {
    if (!suggestionContainer) return;
    var productItems = suggestionContainer.querySelectorAll('.boost-pfs-search-suggestion-item-product');
    productItems.forEach(function (li) {
      // --- FIX 1: Remove aria-label from <li> so screen reader doesn't announce
      //     "products: Title" before also announcing the link text --- double-read gone.
      if (li.hasAttribute('aria-label')) {
        li.removeAttribute('aria-label');
      }
      // Keep role="option" but remove the redundant aria-label

      var link = li.querySelector('a');
      if (!link) return;

      // Ensure the <a> is keyboard-focusable (Boost PFS sets tabindex="-1")
      link.setAttribute('tabindex', '0');

      // --- FIX 2: Build a single clean aria-label on <a> ---
      // Use li data-title (most reliable) and price text
      var productTitle = li.getAttribute('data-title') || '';
      var priceEl = li.querySelector('.boost-pfs-search-suggestion-product-price');
      var priceText = priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : '';
      var imgEl = li.querySelector('img');
      // Use img alt only if it adds info beyond the title
      var imgAlt = imgEl ? (imgEl.getAttribute('alt') || '').trim() : '';

      var ariaLabel = 'Product: ' + productTitle;
      if (priceText) ariaLabel += ', Price: ' + priceText;
      link.setAttribute('aria-label', ariaLabel);

      // --- FIX 3: Silence inner text nodes so only aria-label is read ---
      var innerTitleEl = li.querySelector('.boost-pfs-search-suggestion-product-title');
      if (innerTitleEl) innerTitleEl.setAttribute('aria-hidden', 'true');
      if (priceEl) priceEl.setAttribute('aria-hidden', 'true');

      // --- FIX 4: Image — include alt in accessible name via role="img" span,
      //    but since <a> has aria-label the img alt won't be read separately.
      //    Mark the img as presentational (info is in the link aria-label).
      if (imgEl) {
        imgEl.setAttribute('role', 'presentation');
        imgEl.setAttribute('alt', '');
        imgEl.removeAttribute('tabindex');
      }
      // Hide the left image wrapper so its alt doesn't get picked up by some screen readers
      var leftDiv = li.querySelector('.boost-pfs-search-suggestion-left');
      if (leftDiv) leftDiv.setAttribute('aria-hidden', 'true');
    });
  }

  function handleSearchPopupTab(e) {
    if (e.key !== 'Tab') return;

    var overlay = document.querySelector('.search-overlay.is-opened');
    var lightbox = document.querySelector('.search__lightbox');
    var isBoostOpen = document.querySelector('.boost-pfs-search-suggestion-open');

    if (!overlay && !lightbox && !isBoostOpen) return;

    var container = overlay || lightbox || document.body;
    var inputSelector = 'input[type="text"][name="q"], .boost-pfs-search-box, input[data-q]';
    var closeSelector = '.search-overlay__close, .fancybox-close-small, [data-fancybox-close], .boost-pfs-search-btn-close-suggestion';
    var titleSelector = '.search-overlay__title, .search-popup__title';

    var active = document.activeElement;

    var input = (active && active.closest(inputSelector)) || container.querySelector(inputSelector) || document.querySelector(inputSelector);
    var closeBtn = (active && active.closest(closeSelector)) || container.querySelector(closeSelector) || document.querySelector(closeSelector);
    var title = (active && active.closest(titleSelector)) || container.querySelector(titleSelector) || document.querySelector(titleSelector);

    if (title && !title.hasAttribute('tabindex')) {
      title.setAttribute('tabindex', '0');
    }
    if (closeBtn && !closeBtn.hasAttribute('tabindex')) {
      closeBtn.setAttribute('tabindex', '0');
    }

    var suggestionContainer = document.querySelector('.boost-pfs-search-suggestion-wrapper, .boost-pfs-search-suggestion');
    var isSuggestionVisible = suggestionContainer && !!(suggestionContainer.offsetWidth || suggestionContainer.offsetHeight || suggestionContainer.getClientRects().length);
    var items = isSuggestionVisible ? getSuggestionItems(suggestionContainer) : [];

    // Patch accessibility on visible items (idempotent; also called from arrow key handler)
    if (items.length > 0) patchSearchItemAccessibility(suggestionContainer);

    var activeItemIndex = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i] === active || items[i].contains(active)) {
        activeItemIndex = i;
        break;
      }
    }

    var isInputActive = !!(active && active.closest(inputSelector));
    var isCloseActive = !!(active && active.closest(closeSelector));
    var isTitleActive = !!(active && active.closest(titleSelector));

    if (e.shiftKey) {
      // Shift + Tab (Backward Loop)
      if (activeItemIndex > 0) {
        e.preventDefault();
        items[activeItemIndex - 1].focus();
      } else if (activeItemIndex === 0) {
        e.preventDefault();
        if (input) input.focus();
      } else if (isInputActive) {
        e.preventDefault();
        if (title) title.focus();
        else if (closeBtn) closeBtn.focus();
      } else if (isTitleActive) {
        e.preventDefault();
        if (closeBtn) closeBtn.focus();
        else if (items.length > 0) items[items.length - 1].focus();
        else if (input) input.focus();
      } else if (isCloseActive) {
        e.preventDefault();
        if (items.length > 0) items[items.length - 1].focus();
        else if (input) input.focus();
      } else {
        e.preventDefault();
        if (input) input.focus();
      }
    } else {
      // Tab (Forward Loop)
      if (isInputActive) {
        e.preventDefault();
        if (items.length > 0) items[0].focus();
        else if (closeBtn) closeBtn.focus();
        else if (title) title.focus();
      } else if (activeItemIndex !== -1 && activeItemIndex < items.length - 1) {
        e.preventDefault();
        items[activeItemIndex + 1].focus();
      } else if (items.length > 0 && activeItemIndex === items.length - 1) {
        // Last suggestion item -> move to close button
        e.preventDefault();
        if (closeBtn) closeBtn.focus();
        else if (title) title.focus();
        else if (input) input.focus();
      } else if (isCloseActive) {
        e.preventDefault();
        if (title) title.focus();
        else if (input) input.focus();
      } else if (isTitleActive) {
        e.preventDefault();
        if (input) input.focus();
      } else {
        e.preventDefault();
        if (input) input.focus();
      }
    }
  }

  // Handle Enter/Space on custom close button
  function handleCloseButtonKeydown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      var active = document.activeElement;
      if (active && active.classList.contains('search-overlay__close')) {
        e.preventDefault();
        active.click();
      }
    }
  }

  // Auto-focus search input field when search trigger is activated.
  // Also calls showSearch() directly as a safety fallback in case the theme's
  // jQuery delegated listener hasn't initialized yet (first-load race condition).
  function handleSearchTrigger(e) {
    var isClick = e.type === 'click';
    var isKey = e.type === 'keydown' && (e.key === 'Enter' || e.key === ' ');

    if (isClick || isKey) {
      var trigger = e.target.closest('[data-show-search-trigger]');
      if (trigger) {
        // Directly call showSearch() if the theme hasn't registered its delegated handler yet
        // (race condition on first page load before jsHeader.init() completes)
        setTimeout(function () {
          var overlay = document.querySelector('.search-overlay.is-opened');
          var lightbox = document.querySelector('.search__lightbox');

          // If popup hasn't opened yet (theme handler may not have fired), open it now
          if (!overlay && !lightbox) {
            if (
              window.PXUTheme &&
              window.PXUTheme.jsHeader &&
              typeof window.PXUTheme.jsHeader.showSearch === 'function'
            ) {
              window.PXUTheme.jsHeader.showSearch();
            }
          }

          // Re-check after popup opens and focus the input
          setTimeout(function () {
            var openOverlay = document.querySelector('.search-overlay.is-opened');
            var openLightbox = document.querySelector('.search__lightbox');
            if (openOverlay) {
              var input = openOverlay.querySelector('input[type="text"][name="q"]');
              if (input) input.focus();
            } else if (openLightbox) {
              var input = openLightbox.querySelector('.js-search-popup input[type="text"][name="q"]');
              if (input) input.focus();
            }
          }, 200);
        }, 150);
      }
    }
  }

  // Handle Arrow keys (Left, Right, Up, Down) for navigating search results
  function handleSearchArrowKeys(e) {
    var isArrow = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) !== -1;
    if (!isArrow) return;

    var overlay = document.querySelector('.search-overlay.is-opened');
    var lightbox = document.querySelector('.search__lightbox');
    var isBoostOpen = document.querySelector('.boost-pfs-search-suggestion-open');

    var suggestionContainer = document.querySelector('.boost-pfs-search-suggestion-wrapper, .boost-pfs-search-suggestion');
    var isSuggestionVisible = suggestionContainer && !!(suggestionContainer.offsetWidth || suggestionContainer.offsetHeight || suggestionContainer.getClientRects().length);

    if (!overlay && !lightbox && !isBoostOpen && !isSuggestionVisible) return;

    // STOP PROPAGATION in capture phase so home page carousels (Flickity) do NOT catch ArrowLeft/ArrowRight!
    e.stopImmediatePropagation();

    var container = overlay || lightbox || document.body;
    var input = container.querySelector('input[type="text"][name="q"], .boost-pfs-search-box');
    var active = document.activeElement;

    if (!isSuggestionVisible) {
      var closeBtn = container.querySelector('.search-overlay__close, .fancybox-close-small, [data-fancybox-close]');
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        if (active === input && closeBtn) {
          e.preventDefault();
          closeBtn.focus();
        }
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        if (active === closeBtn && input) {
          e.preventDefault();
          input.focus();
        }
      }
      return;
    }

    var items = getSuggestionItems(suggestionContainer);
    if (items.length === 0) return;

    // Always patch accessibility on current items (idempotent setAttribute calls)
    patchSearchItemAccessibility(suggestionContainer);

    items.forEach(function (item) {
      // Boost PFS may reset tabindex="-1"; force 0 just before focus
      item.setAttribute('tabindex', '0');
    });

    // Match activeIndex ONLY against document.activeElement
    var activeIndex = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i] === active || items[i].contains(active)) {
        activeIndex = i;
        break;
      }
    }

    var isForward = (e.key === 'ArrowDown' || e.key === 'ArrowRight');
    var isBackward = (e.key === 'ArrowUp' || e.key === 'ArrowLeft');

    function updateSelectedClass(targetEl) {
      var allSelected = suggestionContainer.querySelectorAll('.selected');
      allSelected.forEach(function (el) { el.classList.remove('selected'); });
      if (targetEl) {
        var itemParent = targetEl.closest('.boost-pfs-search-suggestion-item') || targetEl;
        itemParent.classList.add('selected');
      }
    }

    if (isForward) {
      e.preventDefault();
      if (active === input || activeIndex === -1) {
        // Move from input to 1st product item
        items[0].focus();
        updateSelectedClass(items[0]);
      } else {
        // Move to next product item
        var nextIndex = (activeIndex < items.length - 1) ? activeIndex + 1 : activeIndex;
        items[nextIndex].focus();
        updateSelectedClass(items[nextIndex]);
      }
    } else if (isBackward) {
      e.preventDefault();
      if (activeIndex <= 0) {
        // Return focus to input if at 1st product or input
        if (input) input.focus();
        var allSelected = suggestionContainer.querySelectorAll('.selected');
        allSelected.forEach(function (el) { el.classList.remove('selected'); });
      } else {
        // Move to previous product item
        var prevIndex = activeIndex - 1;
        items[prevIndex].focus();
        updateSelectedClass(items[prevIndex]);
      }
    }
  }

  document.addEventListener('keydown', handleSearchPopupTab);
  document.addEventListener('keydown', handleCloseButtonKeydown);
  document.addEventListener('keydown', handleSearchArrowKeys, true);
  document.addEventListener('click', handleSearchTrigger);
  document.addEventListener('keydown', handleSearchTrigger);
})();
